export default {
  getAccount (VueApp, driverId, callback) {
    VueApp.$sdk.get('/provider/' + driverId + '/account', {
      token: VueApp.$store.state.session.sessionToken
    }, callback)
  },

  getTransactions (VueApp, request, callback) {
    VueApp.$sdk.get('/admin/prov/transaction', request, callback)
  },

  updateTransaction (VueApp, trxId, request, callback) {
    VueApp.$sdk.post('/admin/prov/transaction/' + trxId, request, callback)
  },

  createTransaction (VueApp, provId, request, callback) {
    VueApp.$sdk.post('/admin/prov/' + provId + '/transaction', request, callback)
  },

  getBalance (VueApp, request, callback) {
    VueApp.$sdk.get('/admin/balance', request, callback)
  },

  getTotal (VueApp, request, callback) {
    VueApp.$sdk.get('/admin/prov/batch/total', request, callback)
  },

  createTopup (VueApp, request, callback) {
    VueApp.$sdk.post('/admin/balance', request, callback)
  },

  startAutodeposit (VueApp, request, callback) {
    VueApp.$sdk.post('/admin/autodeposit', request, callback)
  },

  getProviderBatch (VueApp, request, callback) {
    VueApp.$sdk.get('/admin/prov/batch', request, callback)
  },

  updateBatch (VueApp, batchId, request, callback) {
    VueApp.$sdk.post('/admin/prov/batch/' + batchId, request, callback)
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/provider/payouts.js